import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
    createStyles,
    Button,
    Collapse,
    TextInput,
    Text,
    Image,
    Container,
    ActionIcon,
    List,
    ThemeIcon,
    Card,
    Group,
    Stack
} from '@mantine/core';
import {
    Dropzone,
    MIME_TYPES
} from '@mantine/dropzone';
import {
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { 
    IconBrandYoutube,
    IconLetterX,
    IconCircleLetterX,
    IconTrash,
    IconChevronUp,
    IconChevronDown,
} from '@tabler/icons';

import { ResponsiveCarouselCardB } from '../components/ResponsiveCarouselCardB';


import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    carCreatorArrayUpdate
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';

import {
    fieldInfoUpdated,
    selectSectionData,
    arrayAddition
} from '../features/home/homeSlice';

const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    linkStyles: {
        fontColor: 'blue !important',
        textDecoration: 'underline'
    },
    linkDisplayContain: {
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto'
    },
    linkDisplayItem: {
        width: '100%'
    }
    
}));

//descript:textinput --> url validation --> list item created
//of_note:add x to remove list item(set up correct redux )
export function CarCreationCardCVideoEmbedding(
    {
        placeHolder,
        itemLabel,
        itemName,
    }
    ) {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const component_md = {
        par: 'auctions',
        child: 'carCreatorData',
        section: 'mediaGallerySection_6',
    }
    const linkRef = React.createRef();
    console.log(`current item name: \n\n${itemName}`)
    
    const n_LinkList = useSelector(selectSectionData(
        {
            par: component_md['par'],
            child: component_md['child'],
            section: component_md['section'],
            item: itemName
        }
    ))

    const moveItem = (direction, index) => {
        console.log(`Move the item @ index ${index} ${direction}`);
    };
    
    console.log(n_LinkList);
    const linkChildren = n_LinkList.map((link, index) => {
        return(
            <Card
                key={nanoid()}
                withBorder={true}
                maw={800}
                mx="auto"
                radius="md"
                className={classes.linkDisplayItem}
            >
                <Group position="apart">
                    <ActionIcon variant="outline" mx="auto" onClick={() => {moveItem('down', index)}}>
                        <IconChevronDown size={18} color="black"/>
                    </ActionIcon>
                    <ActionIcon variant="outline" mx="auto" onClick={() => {moveItem('del', index)}}>
                        <IconTrash size={18} color="red"/>
                    </ActionIcon>
                    <ActionIcon variant="outline" mx="auto" onClick={() => {moveItem('up', index)}}>
                        <IconChevronUp size={18} color="black"/>
                    </ActionIcon>
                </Group>
                <br/>
                <Stack>
                    <a href={link} className={classes.linkStyles}>
                        <Text td="underline" c="blue">
                            {link}
                        </Text>
                    </a>
                </Stack>
            </Card>
        );
    })

    const onLinkChanged = (e) => {
        console.log(linkRef.current);
        console.log(linkRef.current.value);
        //need dispatch event here
        //once updated reset value of text box
        //setDescript(e.target.value);
        if (linkRef.current.value.length > 0){
            dispatch(arrayAddition(
                {
                    itemVal: linkRef.current.value,
                    par: component_md['par'],
                    child: component_md['child'],
                    section: component_md['section'],
                    item: itemName
                }
            ))
            linkRef.current.value = '';
        }
    }
    
    const [linkPreview, setLinkPreviewOpen] = useState(false);
    const onLinkPreviewOpen = (e) => setLinkPreviewOpen((o) => !o);
    
    
    
    return (
        <>
            <TextInput
                placeholder={placeHolder}
                label={itemLabel}
                ref={linkRef}
                icon={<IconBrandYoutube size={14}/>}
            />
            <br/>
            <Group position="apart">
                <Button color="green" onClick={onLinkChanged}>
                    Add Video
                </Button>
                {n_LinkList.length > 0 &&
                    <>
                        <Button color="blue" onClick={onLinkPreviewOpen}>
                            View Links
                        </Button>
                        <Collapse className={classes.linkDisplayContain} in={linkPreview} transitionDuration={1000} transitionTimingFunction="linear">
                            {linkChildren}
                        </Collapse>
                    </>
                }
            </Group>
            <br/>
        
        
        </>
    );
}
